import { Star } from "lucide-react";

export default function ConfidenceStars({ value = 0, size = 16, color = "#39FF14", emptyColor = "#2A3B30" }) {
  return (
    <span className="inline-flex items-center gap-0.5" data-testid="confidence-stars" aria-label={`${value} étoiles`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          strokeWidth={2}
          style={{ color: i <= value ? color : emptyColor, fill: i <= value ? color : "transparent" }}
        />
      ))}
    </span>
  );
}
